import React from 'react';
import styled from 'styled-components';
import logoL from "./../images/portada3_EH.jpg";
const AcercaDe = () => {
    return ( 
      <ContenedorAcercaDe>
             <Column>
                <h2>Electronica HERTZ </h2>
                <br></br>
                <p>Un comercio que se dedicada a la Reparacion y Servicio Tecnico de Audio y TV. </p>
                <p> Con mas de 10 años de experiencia en el rubro, cumpliendo con las necesidades de nuestros clientes, para los cual nos
                   capacitamos  constantemente porque el avance tecnologico asi lo requiere.</p>
                <p>Hemos incorpado la venta de accesorios para audio y TV.</p>
             </Column>
             <Column>
             <img src={logoL} width="650" height="320"></img>
             </Column>
             
      </ContenedorAcercaDe>
            
     );
}
 
export default AcercaDe;

const ContenedorAcercaDe= styled.div`
   
   justify-content: space-between;   
    max-width: 2000px;
    padding: 10px;
    width: 90%;
    display: flex;
      
    background: #fff;
    margin: 10px 0;
 
`;

const Column = styled.div`
  width: 48%; /* Ajusta el ancho según tus necesidades */
  padding: 10px;
  /* Puedes agregar más estilos según lo que necesites */
`;